// extracted by mini-css-extract-plugin
export default {"dialog":"BlockDialog_dialog__s-Ya8","title":"BlockDialog_title__BcKoz","content":"BlockDialog_content__Q0ZVs","actions":"BlockDialog_actions__yd3BM"};